import { useLocale } from '@ecomm/data-hooks'
import { type CartValue, cartAddItem } from '@ecomm/data-simplisafe-api'
import { getCartId } from '@ecomm/data-storage'
import * as E from 'fp-ts/lib/Either'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useCallback } from 'react'

import { useSetCart } from '../atoms/useCart'

type Products = readonly {
  readonly sku: string
  readonly quantity: number
}[]

export const useCartAddItem = (products: Products, variationId: string) => {
  const cartId = getCartId()
  const setCart = useSetCart()
  const locale = useLocale()

  return useCallback(
    (successFn: (t: CartValue) => void) => {
      const fn = async (id?: string) => {
        setCart(['set_cart_updating'])

        const cart = await cartAddItem(locale, products, id, variationId)()

        pipe(
          cart,
          E.fold(
            err => setCart(['set_cart_error', err]),
            t => {
              setCart(['update_cart', t])
              successFn(t)
            }
          )
        )
      }

      pipe(
        O.fromNullable(cartId),
        O.fold(
          () => fn(),
          id => fn(id)
        )
      )
    },
    [cartId, setCart, locale, products, variationId]
  )
}
